"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/defineProperty"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _lodash = _interopRequireDefault(require("lodash"));
var _strftime = _interopRequireDefault(require("strftime"));
var _ircFramework = _interopRequireDefault(require("irc-framework"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _TypingMiddleware = _interopRequireDefault(require("./TypingMiddleware"));
var _ChathistoryMiddleware = _interopRequireDefault(require("./ChathistoryMiddleware"));
var ServerConnection = _interopRequireWildcard(require("./ServerConnection"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function create(state, network) {
  var networkid = network.id;
  var ircClient = new _ircFramework.default.Client({
    // Most options are set under the overloaded .connect()
    version: null,
    enable_chghost: true,
    enable_setname: true,
    message_max_length: 350
  });
  ircClient.requestCap('znc.in/self-message');
  ircClient.use((0, _ChathistoryMiddleware.default)());
  ircClient.use(clientMiddleware(state, network));
  ircClient.use((0, _TypingMiddleware.default)());

  // Overload the connect() function to make sure we are connecting with the
  // most recent connection details from the network state
  var originalIrcClientConnect = ircClient.connect;
  ircClient.connect = function connect() {
    // Set some defaults if we don't have eveything
    if (!network.connection.nick) {
      network.connection.nick = 'Guest' + Math.floor(Math.random() * 100);
    }
    ircClient.options.host = network.connection.server;
    ircClient.options.port = network.connection.port;
    ircClient.options.tls = network.connection.tls;
    ircClient.options.path = network.connection.path;
    ircClient.options.password = network.connection.password;
    if (network.password) {
      ircClient.options.account = {
        account: network.connection.nick,
        password: network.password
      };
    } else {
      // No password so give an empty account config. This forces irc-framework to keep
      // the server password (options.password) separate from SASL
      ircClient.options.account = {};
    }
    ircClient.options.nick = network.connection.nick;
    ircClient.options.username = network.username || network.connection.nick;
    ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
    ircClient.options.encoding = network.connection.encoding;
    ircClient.options.auto_reconnect = !!state.setting('autoReconnect');
    ircClient.options.sasl_disconnect_on_fail = !!state.setting('disconnectOnSaslFail');

    // Apply any irc-fw options specified in kiwiirc config
    var configOptions = state.setting('ircFramework');
    if (configOptions) {
      (0, _assign.default)(ircClient.options, configOptions);
    }
    var eventObj = {
      network: network,
      transport: null
    };
    state.$emit('network.connecting', eventObj);
    if (eventObj.transport) {
      // A plugin might use its own transport of some kind
      ircClient.options.transport = eventObj.transport;
    } else if (!network.connection.direct) {
      // A direct connection uses a websocket to connect (note: some browsers limit
      // the number of connections to the same host!).
      // A non-direct connection will connect via the configured kiwi server using
      // with our own irc-framework compatible transport.
      ircClient.options.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
    } else {
      // Use the irc-framework default transport
      ircClient.options.transport = undefined;
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    originalIrcClientConnect.apply(ircClient, args);
  };

  // Overload the raw() function so that we can emit outgoing IRC messages to plugins
  var originalIrcClientRaw = ircClient.raw;
  ircClient.raw = function raw() {
    var message = null;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (args[0] instanceof _ircFramework.default.Message) {
      message = args[0];
    } else {
      var rawString = ircClient.rawString.apply(ircClient, args);
      message = _ircFramework.default.ircLineParser(rawString);
    }
    var eventObj = {
      network: network,
      message: message,
      handled: false
    };
    state.$emit('ircout', eventObj);
    if (eventObj.handled) {
      return;
    }

    // Workaround for unsetting the topic as to1459() will remove the trailing colon.
    var isTopic = args.length === 1 && typeof args[0] === 'string' && args[0].indexOf('TOPIC') === 0;
    if (isTopic && args[0].lastIndexOf(':') === args[0].length - 1) {
      originalIrcClientRaw.apply(ircClient, args);
      return;
    }
    originalIrcClientRaw.apply(ircClient, [message]);
  };
  ircClient.on('raw', function (event) {
    if (!network.setting('show_raw') && !state.setting('showRaw')) {
      return;
    }
    var buffer = state.getOrAddBufferByName(networkid, '*raw');
    state.addMessage(buffer, {
      time: Date.now(),
      nick: '',
      message: (event.from_server ? '[S] ' : '[C] ') + event.line
    });
  });
  ircClient.on('typing', function (event) {
    var user = state.getUser(network.id, event.nick);
    if (user) {
      user.typingStatus(event.target, event.status);
    }
  });
  return ircClient;
}
function clientMiddleware(state, network) {
  var networkid = network.id;
  // eslint-disable-next-line
  var numConnects = 0;
  var isRegistered = false;
  return function middlewareFn(client, rawEvents, parsedEvents) {
    parsedEvents.use(parsedEventsHandler);
    rawEvents.use(rawEventsHandler);
    client.on('connecting', function () {
      network.state_error = '';
      network.state = 'connecting';
      network.last_error = '';
      network.last_error_numeric = 0;
    });
    client.on('connected', function () {
      network.state_error = '';
      network.state = 'connected';
      var currentUser = network.currentUser();
      if (currentUser) {
        currentUser.away = '';
      }
    });
    client.on('socket close', function (err) {
      isRegistered = false;
      network.state = 'disconnected';
      if (err) {
        network.state_error = typeof err === 'string' ? err : 'err_unknown';
      }
      var currentUser = network.currentUser();
      if (currentUser) {
        currentUser.away = 'offline';
      }
      network.buffers.forEach(function (buffer) {
        if (!buffer) {
          return;
        }
        buffer.joined = false;
        buffer.clearUsers();
      });
    });
  };
  function rawEventsHandler(command, event, rawLine, client, next) {
    // Allow plugins to override raw IRC events
    var eventObj = _objectSpread(_objectSpread({}, event), {}, {
      raw: rawLine,
      handled: false
    });
    state.$emit('irc.raw', command, eventObj, network);
    if (eventObj.handled) {
      return;
    }
    state.$emit('irc.raw.' + command, command, eventObj, network);
    if (eventObj.handled) {
      return;
    }
    if (command === '002') {
      // Your host is server.example.net, running version InspIRCd-2.0
      var param = event.params[1] || '';
      var m = param.match(/running version (.*)$/);
      network.ircd = m ? m[1] : '';
    }
    if (command === 'CAP' && network.setting('show_raw_caps')) {
      var params = (0, _toConsumableArray2.default)(event.params);
      if (params[params.length - 1].indexOf(' ') > -1) {
        params[params.length - 1] = ':' + params[params.length - 1];
      }
      var buffer = network.serverBuffer();
      state.addMessage(buffer, {
        time: Date.now(),
        nick: '',
        message: event.command + ' ' + params.join(' ')
      });
    }
    next();
  }
  function parsedEventsHandler(command, event, client, next) {
    // Trigger this event through the state object first. If it's been handled
    // somewhere else then we ignore it.
    var ircEventObj = {
      handled: false
    };
    state.$emit('irc.' + command, event, network, ircEventObj);
    if (ircEventObj.handled) {
      next();
      return;
    }

    // Ignore any of the control messages. They're transport related to kiwi internals
    if (event && event.command === 'CONTROL') {
      next();
      return;
    }

    // If there is a time difference between this client and the server, convert it
    // to match our local time so it makes sense to the user
    var eventTime = event && event.time ? network.ircClient.network.timeToLocal(event.time) : Date.now();
    var serverTime = event && event.time || 0;
    if (command === 'channel_redirect') {
      var b = network.bufferByName(event.from);
      if (b) {
        (0, _flags.default)(b).redirect_to = event.to;
      }
    }
    if (command === 'registered') {
      isRegistered = true;
      network.nick = event.nick;
      state.addUser(networkid, {
        nick: event.nick,
        username: client.user.username
      });
      var serverBuffer = network.serverBuffer();
      state.addMessage(serverBuffer, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: TextFormatting.t('connected_to', {
          network: client.network.name
        })
      });

      // Get some extra info about ourselves
      client.raw('WHO ' + event.nick);
      if (network.auto_commands) {
        network.auto_commands.split('\n').forEach(function (line) {
          state.$emit('input.raw', line[0] === '/' ? line : "/".concat(line), {
            network: network,
            buffer: serverBuffer
          });
        });
      }

      // Join our channels
      // If under bouncer mode, the bouncer will send the channels were joined to instead.
      if (!network.connection.bncnetid) {
        network.buffers.forEach(function (buffer) {
          if (buffer.isChannel() && buffer.enabled) {
            client.join(buffer.name, buffer.key);
          }
        });
      }
      numConnects++;
    }
    if (command === 'server options') {
      // If the network name has changed from the irc-framework default, update ours
      // Also if it isn't a BNC network as the name is then derived from the BNC info instead
      if (client.network.name !== 'Network' && !network.connection.bncnetid) {
        network.name = client.network.name;
      }
    }

    // Show unhandled data from the server in the servers tab
    if (command === 'unknown command') {
      var _context;
      var buffer = network.serverBuffer();
      var containsNick = event.params[0] === network.ircClient.user.nick;
      var isChannelMessage = network.isChannelName(event.params[1]);
      var message = '';
      if ((0, _includes.default)(_context = ['486', '477']).call(_context, event.command)) {
        // Messages from these events don't need the nick from params[0]
        message = event.params[2];
      } else if (containsNick && isChannelMessage) {
        var _context2;
        // This error is aimed at us and has a target channel
        // replace the target buffer and remove unneeded params
        var channelBuffer = network.bufferByName(event.params[1]);
        if (channelBuffer) {
          buffer = channelBuffer;
        }
        message = (0, _slice.default)(_context2 = event.params).call(_context2, 2).join(', ');
      } else if (containsNick) {
        var _context3;
        // Strip out our nick if it's the first params (many commands include this)
        message = (0, _slice.default)(_context3 = event.params).call(_context3, 1).join(', ');
      } else {
        message = event.params.join(', ');
      }

      // Numerics for restrictions on sending messages to channels/users
      var restrictedMessages = ['486',
      // ERR_NONONREG old numeric used by unreal42
      '477',
      // ERR_NEEDREGGEDNICK
      '716',
      // RPL_TARGUMODEG
      '717' // RPL_TARGNOTIFY
      ];

      if ((0, _includes.default)(restrictedMessages).call(restrictedMessages, event.command)) {
        // You must log in with services to message this user/channel
        // or CallerID +g
        buffer = state.getOrAddBufferByName(network.id, event.params[1]);

        // Only add this message if it does not match the previous message
        // Typing status messages can cause a spam of this error type
        state.addMessageNoRepeat(buffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          message: message,
          type: 'error'
        });
        if (event.command === '477' && buffer.isChannel() && buffer.enabled && !buffer.joined) {
          // The buffer we tried to join requires a registered nick,
          // disable it until the user manually tries to rejoin
          buffer.enabled = false;
        }
      } else {
        // Only show non-numeric commands
        if (!event.command.match(/^\d+$/)) {
          message += event.command + ' ';
        }
        state.addMessage(buffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: message
        });
      }
    }
    if (command.toLowerCase() === 'batch start chathistory' && client.chathistory) {
      // We have a new batch of messages. To prevent duplicate messages being shown, we remove
      // all messages we have locally in the range of these new messages so that the new block
      // of messages we recieved are displayed accurately. Each message in the block will
      // trigger a 'message' event after this.
      var startTime = 0;
      var endTime = 0;
      event.commands.forEach(function (message) {
        if (message.time && message.time > endTime) {
          endTime = message.time;
        }
        if (message.time && message.time < startTime) {
          startTime = message.time;
        }
      });
      if (!startTime || !endTime) {
        return;
      }
      var _buffer = state.getBufferByName(networkid, event.params[0]);
      if (_buffer) {
        _buffer.clearMessageRange(startTime, endTime);
      }
    }
    if (command === 'message') {
      var isPrivateMessage = false;
      var bufferName = event.from_server ? '*' : event.target;

      // If the message came from a batch then params[0] is the bufferName
      if (event.batch && event.batch.type === 'chathistory' && event.batch.params[0]) {
        bufferName = event.batch.params[0];
        isPrivateMessage = !network.isChannelName(bufferName);
      } else if (!event.from_server && event.target === client.user.nick) {
        // PMs should go to a buffer with the name of the other user
        isPrivateMessage = true;
        bufferName = event.nick;
      }

      // Chanserv sometimes PMs messages about a channel on join in the format of
      // [#channel] welcome!
      // Redirect these to #channel
      if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
        bufferName = event.message.substr(1, event.message.indexOf(']') - 1);
      }

      // Notices from somewhere when we don't have an existing buffer for them should go into
      // the server tab. ie. notices from servers
      if (event.type === 'notice') {
        var existingBuffer = state.getBufferByName(networkid, bufferName);
        var noticeActiveBuffer = state.setting('noticeActiveBuffer');
        var activeBuffer = state.getActiveBuffer();
        var hasActiveBuffer = activeBuffer && activeBuffer.networkid === networkid;

        // If we don't have a buffer for this notice sender, either show it in our active
        // buffer or the server buffer
        if (!existingBuffer) {
          if (noticeActiveBuffer && hasActiveBuffer && !activeBuffer.isSpecial()) {
            bufferName = activeBuffer.name;
          } else {
            bufferName = '*';
          }
        }
      }
      var PM_BLOCK_BLOCKED = false;
      // const PM_BLOCK_NOT_BLOCKED = true;
      var PM_BLOCK_REQUIRES_CHECK = null;
      var pmBlock = network.isNickExemptFromPmBlocks(event.nick);
      var blockNewPms = state.setting('buffers.block_pms');
      var _buffer2 = state.getBufferByName(networkid, bufferName);
      var textFormatType = 'privmsg';
      if (event.type === 'action') {
        textFormatType = 'action';
      } else if (event.type === 'notice') {
        textFormatType = 'notice';
      }
      var messageBody = TextFormatting.formatText(textFormatType, {
        nick: event.nick,
        username: event.ident,
        host: event.hostname,
        text: event.message
      });
      var _message = {
        time: eventTime,
        server_time: serverTime,
        nick: event.nick,
        message: messageBody,
        type: event.type,
        tags: event.tags || {}
      };

      // If this is a new PM and the sending user is not exempt from blocks, ignore it
      if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_BLOCKED) {
        return;
      }

      // If we need to manually check if this user is blocked..
      // PM_BLOCK_REQUIRES_CHECK means we should whois the user to get their oper status. We
      // allways allow messages from opers.
      if (blockNewPms && isPrivateMessage && !_buffer2 && pmBlock === PM_BLOCK_REQUIRES_CHECK) {
        // if the nick is in pendingPms it has already issued a whois request
        var awaitingWhois = !!(0, _find.default)(_lodash.default).call(_lodash.default, network.pendingPms, {
          nick: event.nick
        });
        network.pendingPms.push({
          bufferName: bufferName,
          message: _message
        });

        // Don't send another whois if we are already awaiting another
        if (awaitingWhois) {
          return;
        }
        network.ircClient.whois(event.nick, event.nick, function (whoisData) {
          network.pendingPms.forEach(function (pm, idx, obj) {
            var nickLower = pm.message.nick.toLowerCase();
            if (nickLower === whoisData.nick.toLowerCase()) {
              if (whoisData.operator) {
                _buffer2 = state.getOrAddBufferByName(network.id, pm.bufferName);
                state.addMessage(_buffer2, pm.message);
              }
              (0, _splice.default)(obj).call(obj, idx, 1);
            }
          });
        });
        return;
      }

      // Make sure we have a buffer for our message
      if (!_buffer2) {
        _buffer2 = state.getOrAddBufferByName(networkid, bufferName);
      }
      state.addMessage(_buffer2, _message);
    }
    if (command === 'wallops') {
      var _buffer3 = state.getOrAddBufferByName(networkid, '*');
      var _messageBody = TextFormatting.formatText('wallops', {
        text: event.message
      });
      state.addMessage(_buffer3, {
        time: eventTime,
        server_time: serverTime,
        nick: event.nick,
        message: _messageBody,
        type: 'wallops'
      });
    }
    if (command === 'join') {
      // If we have any buffers marked as being redirected to this new channel, update
      // that buffer instead of creating a new one
      if (event.nick === client.user.nick) {
        network.buffers.forEach(function (b) {
          if (((0, _flags.default)(b).redirect_to || '').toLowerCase() === event.channel.toLowerCase()) {
            state.$delete((0, _flags.default)(b), 'redirect_to');
            b.rename(event.channel);
          }
        });
      }
      var _buffer4 = state.getOrAddBufferByName(networkid, event.channel);

      // The case does not match, update buffer.name to the casing sent by the server
      if (_buffer4.name !== event.channel) {
        _buffer4.rename(event.channel);
      }
      state.addUserToBuffer(_buffer4, {
        nick: event.nick,
        username: event.ident,
        host: event.hostname,
        realname: event.gecos,
        account: event.account || ''
      });
      if (event.nick === client.user.nick) {
        _buffer4.enabled = true;
        _buffer4.joined = true;
        (0, _flags.default)(_buffer4).channel_badkey = false;
        network.ircClient.raw('MODE', event.channel);
        network.ircClient.who(event.channel);
      }
      var ignoreEvent = state.setting('skipHiddenMessages') && !_buffer4.setting('show_joinparts');
      if (!ignoreEvent || event.nick === client.user.nick) {
        var nick = _buffer4.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);
        var _messageBody2 = TextFormatting.formatAndT('channel_join', null, 'has_joined', {
          nick: nick
        });
        var typeExtra = event.nick === client.user.nick ? 'join_self' : 'join';
        state.addMessage(_buffer4, {
          time: eventTime,
          server_time: serverTime,
          nick: event.nick,
          message: _messageBody2,
          type: 'traffic',
          type_extra: typeExtra
        });
      }
    }
    if (command === 'kick') {
      var _context4;
      var _buffer5 = state.getOrAddBufferByName(networkid, event.channel);
      state.removeUserFromBuffer(_buffer5, event.kicked);
      if (event.kicked === client.user.nick) {
        _buffer5.joined = false;
        _buffer5.enabled = false;
        _buffer5.clearUsers();
      }
      var _messageBody3 = '';
      var _ignoreEvent = state.setting('skipHiddenMessages') && !_buffer5.setting('show_joinparts');
      var isUserInvolved = (0, _includes.default)(_context4 = [event.kicked, event.nick]).call(_context4, client.user.nick);
      if (!_ignoreEvent || isUserInvolved) {
        if (event.kicked === client.user.nick) {
          _messageBody3 = TextFormatting.formatAndT('channel_selfkick', {
            reason: event.message
          }, 'kicked_you_from', {
            nick: TextFormatting.formatUser(event),
            channel: event.channel
          });
        } else {
          _messageBody3 = TextFormatting.formatAndT('channel_kicked', {
            reason: event.message
          }, 'was_kicked_from', {
            nick: event.kicked,
            channel: event.channel,
            chanop: TextFormatting.formatUser(event.nick)
          });
        }
        var _typeExtra = isUserInvolved ? 'kick_self' : 'kick';
        state.addMessage(_buffer5, {
          time: eventTime,
          server_time: serverTime,
          nick: event.nick,
          message: _messageBody3,
          type: 'traffic',
          type_extra: _typeExtra
        });
      }
    }
    if (command === 'part') {
      var _buffer6 = state.getBufferByName(networkid, event.channel);
      if (!_buffer6) {
        return;
      }
      state.removeUserFromBuffer(_buffer6, event.nick);
      if (event.nick === client.user.nick) {
        _buffer6.joined = false;
        _buffer6.enabled = false;
        _buffer6.clearUsers();
      }

      // Remove the user from network state if no remaining common channels
      var remainingBuffers = state.getBuffersWithUser(networkid, event.nick);
      if (remainingBuffers.length === 0) {
        state.removeUser(networkid, {
          nick: event.nick
        });
      }
      var _ignoreEvent2 = state.setting('skipHiddenMessages') && !_buffer6.setting('show_joinparts');
      if (!_ignoreEvent2 || event.nick === client.user.nick) {
        var _nick = _buffer6.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);
        var _messageBody4 = TextFormatting.formatAndT('channel_part', {
          reason: event.message
        }, 'has_left', {
          nick: _nick
        });
        var _typeExtra2 = event.nick === client.user.nick ? 'part_self' : 'part';
        state.addMessage(_buffer6, {
          time: eventTime,
          server_time: serverTime,
          nick: event.nick,
          message: _messageBody4,
          type: 'traffic',
          type_extra: _typeExtra2
        });
      }
    }
    if (command === 'quit') {
      var buffers = state.getBuffersWithUser(networkid, event.nick);
      buffers.forEach(function (buffer) {
        if (!buffer) {
          return;
        }
        if (event.nick === client.user.nick) {
          buffer.joined = false;
          buffer.clearUsers();
        }
        var ignoreEvent = state.setting('skipHiddenMessages') && !buffer.setting('show_joinparts');
        if (ignoreEvent && event.nick !== client.user.nick) {
          return;
        }
        var nick = buffer.setting('show_hostnames') ? TextFormatting.formatUserFull(event) : TextFormatting.formatUser(event);
        var messageBody = TextFormatting.formatAndT('channel_quit', {
          reason: event.message
        }, 'has_left', {
          nick: nick
        });
        var typeExtra = event.nick === client.user.nick ? 'quit_self' : 'quit';
        state.addMessage(buffer, {
          time: eventTime,
          server_time: serverTime,
          nick: event.nick,
          message: messageBody,
          type: 'traffic',
          type_extra: typeExtra
        });
      });

      // Set the user as away before removing so away status indicators are updated
      var user = state.getUser(networkid, event.nick);
      if (user) {
        user.away = 'offline';
      }
      state.removeUser(networkid, {
        nick: event.nick
      });
    }
    if (command === 'invite') {
      var _buffer7 = network.serverBuffer();
      var activeNetwork = state.getActiveNetwork();
      var _activeBuffer = state.getActiveBuffer();
      if (network === activeNetwork && !_activeBuffer.isSpecial()) {
        _buffer7 = _activeBuffer;
      }
      var translationKey = 'invited_other';
      if (event.invited === network.currentUser().nick) {
        translationKey = 'invited_you';
      } else if (event.nick === network.currentUser().nick) {
        translationKey = 'invited_inviter';
      }
      state.addMessage(_buffer7, {
        nick: '',
        time: eventTime,
        server_time: serverTime,
        type: 'invite',
        message: TextFormatting.t(translationKey, {
          nick: event.nick,
          invited: event.invited,
          channel: event.channel
        })
      });
    }
    if (command === 'account') {
      state.addUser(networkid, {
        nick: event.nick,
        account: event.account || ''
      });
    }
    if (command === 'whois' && !event.error) {
      var userObj = {
        nick: event.nick,
        host: event.hostname,
        username: event.ident,
        realname: event.real_name
      };

      // Whois items that maybe will exist
      ['away', 'account'].forEach(function (prop) {
        if (typeof event[prop] !== 'undefined') {
          userObj[prop] = event[prop] || '';
        }
      });
      var _user = state.addUser(networkid, userObj);
      (0, _keys.default)(_user.whois).forEach(function (prop) {
        var _event$prop;
        return _user.whois[prop] = (_event$prop = event[prop]) !== null && _event$prop !== void 0 ? _event$prop : '';
      });
      _user.hasWhois = true;
    }
    if (command === 'away') {
      state.addUser(networkid, {
        nick: event.nick,
        away: event.message || ''
      });
      var _buffer8 = state.getActiveBuffer();
      if (_buffer8 && event.nick === client.user.nick) {
        network.away = 'away';
        state.addMessage(_buffer8, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          type: 'presence',
          message: event.message
        });
      }
    }
    if (command === 'back') {
      state.addUser(networkid, {
        nick: event.nick,
        away: ''
      });
      var _buffer9 = state.getActiveBuffer();
      if (_buffer9 && event.nick === client.user.nick) {
        network.away = '';
        state.addMessage(_buffer9, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          type: 'presence',
          message: event.message
        });
      }
    }
    if (command === 'wholist') {
      state.usersTransaction(networkid, function (users) {
        event.users.forEach(function (eventUser) {
          var userObj = {
            nick: eventUser.nick,
            host: eventUser.hostname || undefined,
            username: eventUser.ident || undefined,
            away: eventUser.away ? 'Away' : '',
            realname: eventUser.real_name,
            account: eventUser.account || undefined
          };
          var user = state.addUser(networkid, userObj, users);
          if (!user) {
            // Should never happen as this network should always exist
            return;
          }
          var buffer = network.bufferByName(eventUser.channel);
          if (!buffer || !user.buffers[buffer.id]) {
            return;
          }

          // Add all the user channel modes
          var modes = user.buffers[buffer.id].modes;
          eventUser.channel_modes.forEach(function (mode) {
            if (modes.indexOf(mode) === -1) {
              modes.push(mode);
            }
          });
          (0, _keys.default)(user.whoFlags).forEach(function (flag) {
            if (typeof eventUser[flag] === 'boolean') {
              user.whoFlags[flag] = eventUser[flag];
            }
          });
          user.hasWhoFlags = true;
        });
      });
    }
    if (command === 'channel list start') {
      network.channel_list_cache = [];
      network.channel_list_state = 'updating';
    }
    if (command === 'channel list') {
      var _context5;
      network.channel_list_state = 'updating';
      // Filter private channels from the channel list
      var filteredEvent = (0, _filter.default)(_lodash.default).call(_lodash.default, event, function (o) {
        return o.channel !== '*';
      });
      // Store the channels in channel_list_cache before moving it all to
      // channel_list at the end. This gives a huge performance boost since
      // it doesn't need to be all reactive for every update
      network.channel_list_cache = (0, _concat.default)(_context5 = network.channel_list_cache || []).call(_context5, filteredEvent);
    }
    if (command === 'channel list end') {
      network.channel_list = network.channel_list_cache || [];
      network.channel_list_state = 'updated';
      delete network.channel_list_cache;
    }
    if (command === 'motd') {
      var _buffer10 = network.serverBuffer();
      var _messageBody5 = TextFormatting.formatText('motd', {
        text: event.motd
      });
      state.addMessage(_buffer10, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody5,
        type: 'motd'
      });
    }
    if (command === 'nick in use') {
      var shouldChangeNick = !client.connection.registered && state.setting('changeNickOnCollision');
      var newNick = event.nick.replace(/\d+$/, '') + rand(1, 99);
      var _translationKey = shouldChangeNick ? 'nick_in_use_retrying' : 'error_nick_in_use';
      var translationVars = {
        nick: event.nick,
        newnick: newNick
      };
      var _messageBody6 = TextFormatting.formatAndT('nickname_alreadyinuse', null, _translationKey, translationVars);
      var _message2 = {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody6,
        type: 'error'
      };
      var _activeBuffer2 = state.getActiveBuffer();
      var _buffer11 = network.serverBuffer();
      if (_activeBuffer2 && _activeBuffer2.networkid === network.id) {
        _buffer11 = _activeBuffer2;
      }
      if (_buffer11) {
        state.addMessage(_buffer11, _message2);
      }
      if (shouldChangeNick) {
        client.changeNick(newNick);
      } else if (!client.connection.registered) {
        network.last_error = _messageBody6;
        network.ircClient.connection.end();
      }
    }
    if (command === 'nick') {
      if (event.nick === client.user.nick) {
        network.nick = event.new_nick;
      }
      state.changeUserNick(networkid, event.nick, event.new_nick);
      var _messageBody7 = TextFormatting.formatAndT('nick_changed', null, 'now_known_as', {
        nick: event.nick,
        newnick: event.new_nick
      });
      var _typeExtra3 = event.nick === client.user.nick ? 'nick_self' : '';
      var _buffers = state.getBuffersWithUser(networkid, event.new_nick);
      _buffers.forEach(function (buffer) {
        var ignoreEvent = state.setting('skipHiddenMessages') && !buffer.setting('show_nick_changes');
        if (ignoreEvent && event.nick !== client.user.nick) {
          return;
        }
        state.addMessage(buffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody7,
          type: 'nick',
          type_extra: _typeExtra3
        });
      });
    }
    if (command === 'userlist') {
      var _context6;
      var _buffer12 = state.getOrAddBufferByName(networkid, event.channel);
      var ucNick = client.user.nick.toUpperCase();
      var hadExistingUsers = (0, _filter.default)(_context6 = (0, _keys.default)(_buffer12.users)).call(_context6, function (u) {
        return u !== ucNick;
      }).length > 0;
      var users = [];
      event.users.forEach(function (user) {
        users.push({
          user: {
            nick: user.nick,
            username: user.ident,
            hostname: user.hostname
          },
          modes: user.modes
        });
      });
      state.addMultipleUsersToBuffer(_buffer12, users);
      if (!hadExistingUsers && network.ircClient.chathistory.isSupported()) {
        var _context7;
        // TODO: If this is a reconnect (numConnects > 1) then paginate backwards
        //       until we reach our last message.
        //       OR
        //       Add a marker at the gap between this new chathistory block starts and when
        //       the existing messages end so that we can add a "load missing messages"
        //       button there or have it auto request them when it scrolls into view
        if (_buffer12.isChannel() && (0, _includes.default)(_context7 = ['all', 'channels']).call(_context7, _buffer12.setting('auto_request_history'))) {
          _buffer12.requestLatestScrollback();
        }
      }
    }
    if (command === 'user updated') {
      var _user2 = network.userByName(event.nick);
      if (_user2) {
        (0, _entries.default)(event).forEach(function (_ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];
          if (key.indexOf('new_') !== 0) {
            return;
          }
          var paramName = key.substr(4);
          switch (paramName) {
            case 'gecos':
              _user2.realname = val;
              break;
            case 'ident':
              _user2.username = val;
              break;
            case 'hostname':
              _user2.host = val;
              break;
            default:
          }
        });
      }
    }
    if (command === 'channel info') {
      var _buffer13 = network.bufferByName(event.channel);
      if (!_buffer13) {
        return;
      }
      if (event.modes) {
        var modeStrs = [];
        event.modes.forEach(function (mode) {
          var adding = mode.mode[0] === '+';
          var modeChar = mode.mode.substr(1);
          if (adding) {
            state.$set(_buffer13.modes, modeChar, mode.param);
          } else if (!adding) {
            state.$delete(_buffer13.modes, modeChar);
          }
          modeStrs.push(mode.mode + (mode.param ? ' ' + mode.param : ''));
        });
        if ((0, _flags.default)(_buffer13).requested_modes) {
          state.addMessage(_buffer13, {
            time: eventTime,
            server_time: serverTime,
            nick: '*',
            message: _buffer13.name + ' ' + modeStrs.join(', ')
          });
        }
      }
      if (event.created_at) {
        _buffer13.created_at = new Date(event.created_at * 1000);
      }
      if (event.created_at && (0, _flags.default)(_buffer13).requested_modes) {
        var tFormat = _buffer13.setting('timestamp_full_format');
        var timeCreated = tFormat ? (0, _strftime.default)(tFormat, new Date(event.created_at * 1000)) : new Date(event.created_at * 1000).toLocaleString();
        state.addMessage(_buffer13, {
          time: eventTime,
          server_time: serverTime,
          nick: '*',
          message: _buffer13.name + ' ' + timeCreated
        });
      }
    }
    if (command === 'mode') {
      var _buffer14 = network.bufferByName(event.target);
      var _modeStrs = {};
      if (_buffer14) {
        // Join all the same mode changes together so they can be shown on one
        // line such as "prawnsalad sets +b on nick1, nick2"
        event.modes.forEach(function (mode) {
          _modeStrs[mode.mode] = _modeStrs[mode.mode] || [];

          // If this mode has a user prefix then we need to update the user object
          var prefix = (0, _find.default)(_lodash.default).call(_lodash.default, network.ircClient.network.options.PREFIX, {
            mode: mode.mode[1]
          });
          if (prefix) {
            var _user3 = state.getUser(network.id, mode.param);
            if (_user3) {
              var adding = mode.mode[0] === '+';
              var modes = _user3.buffers[_buffer14.id].modes;
              var modeIdx = modes.indexOf(prefix.mode);

              // Add or remove the mode from the users mode list
              if (adding && modeIdx === -1) {
                modes.push(prefix.mode);
              } else if (!adding && modeIdx > -1) {
                (0, _splice.default)(modes).call(modes, modeIdx, 1);
              }
            }
            _modeStrs[mode.mode].push({
              target: mode.param
            });
          } else {
            // Not a user prefix, add it as a channel mode
            // TODO: Why are these not appearing as the 'channel info' command?
            var _adding = mode.mode[0] === '+';
            var modeChar = mode.mode.substr(1);
            if (_adding) {
              state.$set(_buffer14.modes, modeChar, mode.param);
            } else if (!_adding) {
              state.$delete(_buffer14.modes, modeChar);
            }
            _modeStrs[mode.mode].push({
              target: _buffer14.name,
              param: mode.param
            });
          }
        });

        // Mode -> locale ID mappings
        // If a mode isn't found here, the local ID modes_other is used
        var modeLocaleIds = {
          '+o': 'modes_give_ops',
          '-o': 'modes_take_ops',
          '+h': 'modes_give_halfops',
          '-h': 'modes_take_halfops',
          '+v': 'modes_give_voice',
          '-v': 'modes_take_voice',
          '+a': 'modes_give_admin',
          '-a': 'modes_take_admin',
          '+q': 'modes_give_owner',
          '-q': 'modes_take_owner',
          '+b': 'modes_gives_ban',
          '-b': 'modes_takes_ban'
        };
        var prefixes = network.ircClient.network.options.PREFIX;
        (0, _keys.default)(modeLocaleIds).forEach(function (mode) {
          var supported = mode[1] === 'b' || (0, _find.default)(prefixes).call(prefixes, function (p) {
            return mode[1] === p.mode;
          });
          if (!supported) {
            delete modeLocaleIds[mode];
          }
        });

        // Some modes have specific data for its locale data while most
        // use a default. The returned objects are passed to the translation
        // functions to build the translation
        var modeLocaleDataBuilders = {
          default: function _default(targets, mode) {
            var _context8;
            var paramStr = (0, _filter.default)(_context8 = (0, _map.default)(targets).call(targets, function (t) {
              return t.param;
            })).call(_context8, function (p) {
              return !!p;
            }).join(', ');
            return {
              mode: mode + (paramStr ? ' ' + paramStr : ''),
              target: targets[0].target,
              nick: event.nick
            };
          },
          b: function b(targets, mode) {
            return {
              mode: mode,
              target: (0, _map.default)(targets).call(targets, function (t) {
                return t.param;
              }).join(', '),
              nick: event.nick
            };
          }
        };

        // Show one line per mode, listing each effecting user
        _lodash.default.each(_modeStrs, function (targets, mode) {
          var _context9, _context10;
          var targetNicks = (0, _map.default)(targets).call(targets, function (t) {
            return t.target;
          });
          var ignoreEvent = state.setting('skipHiddenMessages') && !_buffer14.setting('show_mode_changes');
          var isUserInvolved = (0, _includes.default)(_context9 = (0, _concat.default)(_context10 = [event.nick]).call(_context10, (0, _toConsumableArray2.default)(targetNicks))).call(_context9, client.user.nick);
          if (ignoreEvent && !isUserInvolved) {
            return;
          }

          // Find a locale data builder for this mode
          var builders = modeLocaleDataBuilders;
          var localeDataFn = builders[mode[1]] || builders.default;
          var localeData = localeDataFn(targets, mode);

          // Translate using the built locale data
          var localeKey = modeLocaleIds[mode] || 'modes_other';
          var text = TextFormatting.t(localeKey, localeData);
          var messageBody = TextFormatting.formatText('mode', {
            nick: event.nick,
            username: event.ident,
            host: event.hostname,
            target: targetNicks.join(', '),
            text: text
          });
          var typeExtra = isUserInvolved ? 'mode_self' : '';
          state.addMessage(_buffer14, {
            time: eventTime,
            server_time: serverTime,
            nick: '',
            message: messageBody,
            type: 'mode',
            type_extra: typeExtra
          });
        });
      } else {
        if (event.target === network.nick) {
          var _user4 = network.currentUser();
          event.modes.forEach(function (item) {
            if (item.mode[0] === '+') {
              var _context11;
              var existIdx = (0, _findIndex.default)(_context11 = _user4.modes).call(_context11, function (uItem) {
                return uItem.mode === item.mode[1];
              });
              if (existIdx === -1) {
                _user4.modes.push({
                  mode: item.mode[1],
                  param: item.param
                });
              }
            } else {
              var _context12;
              var removeIdx = (0, _findIndex.default)(_context12 = _user4.modes).call(_context12, function (uItem) {
                return uItem.mode === item.mode[1];
              });
              if (removeIdx !== -1) {
                var _context13;
                (0, _splice.default)(_context13 = _user4.modes).call(_context13, removeIdx, 1);
              }
            }
          });
        }

        // target is not a channel buffer (user mode ?)
        // if mode had param, show in a new line
        var modeslines = {};

        // Group each - or + modes to each of their own message lines
        event.modes.forEach(function (mode) {
          if (mode.param) {
            modeslines[mode.mode] = ' ' + mode.param;
          } else if (mode.mode[0] === '-') {
            var _context14;
            if (!modeslines['-']) {
              modeslines['-'] = '';
            }
            modeslines['-'] += (0, _slice.default)(_context14 = mode.mode).call(_context14, 1);
          } else {
            if (!modeslines['+']) {
              modeslines['+'] = '';
            }
            if (mode.mode[0] === '+') {
              var _context15;
              modeslines['+'] += (0, _slice.default)(_context15 = mode.mode).call(_context15, 1);
            } else {
              modeslines['+'] += mode.mode;
            }
          }
        });
        var _serverBuffer = network.serverBuffer();
        _lodash.default.each(modeslines, function (mode, value) {
          var text = TextFormatting.t('modes_other', {
            nick: event.nick,
            target: event.target,
            mode: value + mode
          });
          var messageBody = TextFormatting.formatText('mode', {
            nick: event.nick,
            username: event.ident,
            host: event.hostname,
            target: event.target,
            text: text
          });
          state.addMessage(_serverBuffer, {
            time: eventTime,
            server_time: serverTime,
            nick: '',
            message: messageBody,
            type: 'mode',
            type_extra: 'mode_self'
          });
        });
      }
    }
    if (command === 'banlist') {
      var _buffer15 = state.getBufferByName(networkid, event.channel);
      var _serverBuffer2 = network.serverBuffer();
      var targetBuffer = _buffer15 || _serverBuffer2;
      if (!_buffer15 || (0, _flags.default)(_buffer15).requested_banlist) {
        var banText = '\x02';
        if (targetBuffer === _serverBuffer2) {
          banText += event.channel + '  ';
        }
        banText += TextFormatting.t('banned') + ' [+b]\x02\n';
        if (!event.bans || event.bans.length === 0) {
          banText += TextFormatting.t('bans_nobody');
        } else {
          _lodash.default.each(event.bans, function (ban) {
            var _context16, _context17;
            var dateStr = new Date(ban.banned_at * 1000).toLocaleDateString();
            banText += (0, _concat.default)(_context16 = (0, _concat.default)(_context17 = "".concat(ban.banned, " [\x1D")).call(_context17, ban.banned_by, ", ")).call(_context16, dateStr, "\x1D]\n");
          });
        }
        state.addMessage(targetBuffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: banText,
          type: 'banlist'
        });
        if (_buffer15) {
          _buffer15.flag('requested_banlist', false);
        }
      }
    }
    if (command === 'inviteList') {
      var _buffer16 = state.getBufferByName(networkid, event.channel);
      var _serverBuffer3 = network.serverBuffer();
      var _targetBuffer = _buffer16 || _serverBuffer3;
      if (!_buffer16 || (0, _flags.default)(_buffer16).requested_invitelist) {
        var inviteText = '\x02';
        if (_targetBuffer === _serverBuffer3) {
          inviteText += event.channel + '  ';
        }
        inviteText += TextFormatting.t('invited') + ' [+I]\x02\n';
        if (!event.invites || event.invites.length === 0) {
          inviteText += TextFormatting.t('invited_nobody');
        } else {
          _lodash.default.each(event.invites, function (invite) {
            var _context18, _context19;
            var dateStr = new Date(invite.invited_at * 1000).toLocaleDateString();
            inviteText += (0, _concat.default)(_context18 = (0, _concat.default)(_context19 = "".concat(invite.invited, " [\x1D")).call(_context19, invite.invited_by, ", ")).call(_context18, dateStr, "\x1D]\n");
          });
        }
        state.addMessage(_targetBuffer, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: inviteText,
          type: 'invitelist'
        });
        if (_buffer16) {
          _buffer16.flag('requested_invitelist', false);
        }
      }
    }
    if (command === 'topic') {
      var _context20;
      var _buffer17 = state.getOrAddBufferByName(networkid, event.channel);
      _buffer17.topic = event.topic || '';
      var _typeExtra4 = '';
      var _messageBody8 = '';
      if (event.nick) {
        _buffer17.topic_by = event.nick;
        _buffer17.topic_when = event.time || Date.now();
        _typeExtra4 = 'topic_change';
        _messageBody8 = TextFormatting.formatAndT('channel_topic', null, 'changed_topic_to', {
          nick: event.nick,
          topic: _buffer17.topic
        });
      } else if ((0, _trim.default)(_context20 = _buffer17.topic).call(_context20)) {
        _typeExtra4 = 'topic_join';
        _messageBody8 = TextFormatting.formatText('channel_topic', _buffer17.topic);
      }
      if (_messageBody8) {
        state.addMessage(_buffer17, {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody8,
          type: 'topic',
          type_extra: _typeExtra4
        });
      }
    }
    if (command === 'topicsetby') {
      var _buffer18 = network.bufferByName(event.channel);
      if (_buffer18) {
        _buffer18.topic_by = event.nick;
        _buffer18.topic_when = event.when * 1000;
      }
    }
    if (command === 'help') {
      var _buffer19 = state.getOrAddBufferByName(networkid, '*help');
      state.addMessage(_buffer19, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: event.help,
        type: 'help',
        tags: event.tags || {}
      });
    }
    if (command === 'ctcp response' || command === 'ctcp request') {
      var _buffer20 = network.bufferByName(event.target) || network.serverBuffer();
      var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';
      var _messageBody9 = TextFormatting.formatText(textFormatId, {
        nick: event.nick,
        message: event.message,
        type: event.type
      });
      state.addMessage(_buffer20, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody9,
        type: 'error'
      });
      if (command === 'ctcp request' && event.type === 'VERSION') {
        var target = event.from_server ? event.hostname : event.nick;
        client.ctcpResponse(target, 'VERSION', 'Kiwi IRC');
      }
    }
    if (command === 'nick invalid') {
      var _messageBody10 = TextFormatting.formatText('general_error', {
        text: event.reason
      });
      var _buffer21 = state.getActiveBuffer();
      state.addMessage(_buffer21, {
        time: eventTime,
        server_time: serverTime,
        nick: '',
        message: _messageBody10,
        type: 'error'
      });
      if (!isRegistered) {
        network.last_error_numeric = 432;
        network.last_error = event.reason;
        network.ircClient.quit();
      }
    }
    if (command === 'loggedin' || command === 'loggedout') {
      var _translationKey2 = command === 'loggedin' ? 'logged_in' : 'logged_out';
      var _buffers2 = [network.serverBuffer()];
      var _activeBuffer3 = state.getActiveBuffer();
      if ((_activeBuffer3 === null || _activeBuffer3 === void 0 ? void 0 : _activeBuffer3.networkid) === network.id && _activeBuffer3 !== _buffers2[0]) {
        _buffers2.push(_activeBuffer3);
      }
      var _messageBody11 = TextFormatting.formatAndT('notice', null, _translationKey2, {
        account: event.account
      });
      _buffers2.forEach(function (buffer) {
        state.addMessage(buffer, {
          time: Date.now(),
          nick: '',
          message: _messageBody11,
          type: 'notice'
        });
      });
    }
    if (command === 'sasl failed') {
      var failMessage = TextFormatting.formatAndT('general_error', null, 'login_failed');
      var _buffers3 = [network.serverBuffer()];
      var _activeBuffer4 = state.getActiveBuffer();
      if ((_activeBuffer4 === null || _activeBuffer4 === void 0 ? void 0 : _activeBuffer4.networkid) === network.id && _activeBuffer4 !== _buffers3[0]) {
        _buffers3.push(_activeBuffer4);
      }
      var disconnectOnSaslFail = network.ircClient.connection.options.sasl_disconnect_on_fail;
      if (disconnectOnSaslFail && network.state !== 'connected') {
        // The client is going to disconnect set last_error so it is show to the user
        network.last_error = failMessage;
      }
      if (!disconnectOnSaslFail) {
        // Only add messages if the client is not going to disconnect on failure
        _buffers3.forEach(function (buffer) {
          state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: failMessage,
            type: 'error'
          });
        });
      }
    }
    if (command === 'irc error') {
      var _buffer22;
      if (event.channel || event.nick) {
        _buffer22 = state.getOrAddBufferByName(network.id, event.channel || event.nick);
      }
      if (!_buffer22) {
        _buffer22 = network.serverBuffer();
      }
      if (!_buffer22) {
        // we could not find a buffer, this is likely because the network was removed
        return;
      }

      // TODO: Some of these errors contain a .error property which we can match against,
      // ie. password_mismatch.

      if (event.error && !isRegistered) {
        if (event.error === 'password_mismatch') {
          network.last_error = TextFormatting.t('error_password_mismatch');
        }
      }
      if (event.error === 'bad_channel_key') {
        (0, _flags.default)(_buffer22).channel_badkey = true;
      }

      // ignore error 432 (erroneous nickname) as it is handled above
      if (event.reason && network.last_error_numeric !== 432) {
        if (!isRegistered) {
          network.last_error = event.reason;
        }
        var messageRaw = event.reason || event.error;
        if (event.error === 'unknown_command') {
          var _context21;
          messageRaw = (0, _concat.default)(_context21 = "".concat(messageRaw, " \"")).call(_context21, event.command, "\"");
        }
        var _messageBody12 = TextFormatting.formatText('general_error', {
          text: messageRaw
        });
        var _message3 = {
          time: eventTime,
          server_time: serverTime,
          nick: '',
          message: _messageBody12,
          type: 'error'
        };
        if (event.error === 'cannot_send_to_channel') {
          // Only add this message if it does not match the previous message
          // Typing status messages can cause a spam of this error type
          state.addMessageNoRepeat(_buffer22, _message3);
          return;
        }
        state.addMessage(_buffer22, _message3);
      }

      // Getting an error about a channel while we are not joined means that we couldn't join
      // or do some action on it. Disable it until we manually reattempt to join.
      if (_buffer22.isChannel() && !_buffer22.joined) {
        _buffer22.enabled = false;
      }
    }
    next();
  }
}
function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IrcClient"]
window._kiwi_exports.libs.IrcClient = exports.default ? exports.default : exports;
